define((require) => {
    "use strict";

    var ImprovedView             = require("editor/zbone/ImprovedView"),
        PasswordQualityValidator = require("util/PasswordQualityValidator"),
        template                 = require("ui/user/PasswordQualityView.tpl");

    /**
     * View that shows information about the quality of a password.
     *
     * @author Poul Henriksen
     * @class PasswordQualityView
     * @constructor
     *
     * @cfg {Backbone.Model} [model]   The model declaring a <tt>password</tt> property to listen for password change.
     * @cfg {jQuery}         [element] The jQuery password element to listen for password change.
     */
    return ImprovedView.extend({
        template: template,
        className: "password-quality",

        ui: {
            upperCase:        ".upper-case",
            lowerCase:        ".lower-case",
            digit:            ".digit",
            specialCharacter: ".special-character",
            length:           ".length"
        },

        modelEvents: {
            "change:password": "_changePasswordModel"
        },

        initialize: function() {
            if (this.options.element) {
                // Bind once and for all so we can remove again explicitly, since a jQuery element, not
                // a Backbone.Model event...
                this._changePasswordElement = this._changePasswordElement.bind(this);
                this.options.element.on("keyup", this._changePasswordElement);
            }
        },

        onClose: function() {
            if (this.options.element) {
                this.options.element.off("keyup", this._changePasswordElement);
            }
        },

        _changePasswordElement: function() {
            this._updateQualities(this.options.element.val());
        },

        _changePasswordModel: function(model, newPassword) {
            this._updateQualities(newPassword);
        },

        _updateQualities: function(password) {
            this.ui.upperCase.toggleClass("valid", PasswordQualityValidator.containsUpperCase(password));
            this.ui.lowerCase.toggleClass("valid", PasswordQualityValidator.containsLowerCase(password));
            this.ui.digit.toggleClass("valid", PasswordQualityValidator.containsDigit(password));
            this.ui.specialCharacter.toggleClass("valid", PasswordQualityValidator.containsSpecialCharacters(password));
            this.ui.length.toggleClass("valid", PasswordQualityValidator.hasMinimumLength(password));
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/user/PasswordQualityView.js